<template>
  <div style="height: 100%">
    <div class="background" :style="sectionBackgroundStyle">
      <div class="overlay"></div>
    </div>
    <div style="position: fixed; width: 100%; height: 100%">
      <v-container
        style="height: 100%"
        class="d-flex flex-column justify-center align-center"
      >
        <h1 class="font-weight-medium text-center white--text mb-4">
          Coming Soon
        </h1>
        <p class="text-center">
          Thank you for creating your account. The tenant page is currently in
          progress.
        </p>
        <p class="text-center">
          In the meantime, all the features you need are available through our
          <a href="viber://pa?chatURI=spacepackph" style="color: white"
            >Viber</a
          >
          chatbot by scanning the QR code below:
        </p>

        <img
          src="https://docs.spacepack.ph/images/4/7/d/0/c/47d0ca733486304f0388566a7eea7a196ea75a0b-viber2023-07-04.png"
          width="200"
          class="my-4"
        />
        <v-btn class="mt-4" depressed @click="logout">Logout</v-btn>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component'],
  data() {
    return {
      username: '',
      password: '',
      sectionBackgroundStyle: `background-image: url(${process.env.BASE_URL}images/cover_img_1.jpg); background-size:cover; background-position: center center;background-attachment:fixed;`
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/doLogout')
      // this.$router.go()
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.95;
  height: 100%;
  background: #662d91;
  background: -moz-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, #662d91),
    color-stop(100%, #798eea)
  );
  background: -webkit-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -ms-linear-gradient(-45deg, #662d91 0%, #798eea 100%);
  background: -webkit-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: -o-linear-gradient(315deg, #662d91 0%, #798eea 100%);
  background: linear-gradient(135deg, #662d91 0%, #798eea 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#662d91', endColorstr='#798eea', GradientType=1 );
}
.login {
  /*background-image: `url(${process.env.BASE_URL}images/cover_img_1.jpg)`;*/
  height: 100%;
}
.v-card {
  background: radial-gradient(
    circle,
    #555555,
    #535353,
    #505050,
    #4e4e4e,
    #4c4c4c
  );
}
.v-form {
  width: 15vw;
}
.link {
  padding-top: 20px;
  text-align: center;
}
.link a {
  text-decoration: none;
  color: white;
  font-size: 20px;
}
.display-1 {
  letter-spacing: 0.5px;
  color: white;
}
.subtitle-2 {
  letter-spacing: 3px;
  color: white;
}
p {
  color: white;
}
</style>
